import HomepageCarousel from "./HomepageCarousel";
import React from 'react';
import styled, {useTheme} from "styled-components";
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";
import {useEffect, useState} from "react";
import HomeStoreActions from "../../flux/HomeStoreActions";
import HomeStore from "../../flux/HomeStore";
import {typologies} from "./HomepageCard";
import RenderOnMobile from "../responsive/RenderOnMobile";
import NoResults from "../NoResults";
import __ from "../../utils/translator";
import PageTitle from "../PageTitle";

export default function HomepageNeverSeenList() {
  const appTheme = useTheme();
  const [neverSeenData, setNeverSeenData] = useState(null);

  const onFetchCompleted = () => {
    const {data} = HomeStore.getState();
    const seasonalData = data.find((elements) => elements.length > 0 && elements[0].typology === typologies.seasonal);
    if (seasonalData !== undefined) {
      setNeverSeenData([
        ...data,
        [
          ...seasonalData
            .filter((collection) => collection.data.manuals.length > 0)
            .map((collection) => ({
              ...collection,
              isNew: collection.manualsNeverSeen,
              typology: typologies.merchandisingManual,
            }))
        ]
      ]);
    } else {
      setNeverSeenData(data);
    }
  }

  useEffect(() => {
    HomeStoreActions.fetchNeverSeen();
    const subscription = HomeStore.addListener(onFetchCompleted)
    return () => {
      subscription.remove();
    };
  }, []);

  if (neverSeenData === null) {
    return null;
  }

  return (
    <Container>
      <PageTitle withTracking title="Home / Never seen" />

      {neverSeenData.every((carousel) => (carousel.length === 0)) ? (
        <NoResults
          message={__('No items found')}
          tip={__('Try again later')}
        />
      ) : (
        neverSeenData.filter((carousel) => carousel.length > 0).map((carousel, i) => (
          <React.Fragment key={carousel[0].typology}>
            {i !== neverSeenData.length - 1 ? ( // Remove merchandising manual carousel on tablet
              <HomepageCarousel
                fullscreen={i === 0 && appTheme.isTablet}
                elements={carousel}
                enableShowAllButton
              />) : (
              <RenderOnMobile>
                <HomepageCarousel
                  elements={carousel}
                />
              </RenderOnMobile>)
            }
          </React.Fragment>
        ))
      )}
    </Container>
  )
}

const Container = styled.div`
  margin-top: ${themeResponsiveProperty(".5rem", "1.5rem")};
`
